<button mat-icon-button
  class="close-dialog"
  (click)="onCancel()">
  <mat-icon>close</mat-icon>
</button>

<h1 mat-dialog-title>
  {{'COMMON.LABEL.REQUEST_INFOS' | translate}}
</h1>

<div mat-dialog-content>
  <div *ngIf="dialogData.publicBundle.vehiclesValuations.length === 1">
    <h3 class="m-0">
      {{'COMMON.LABEL.SELECTED_VEHICLE' | translate}}:
      {{dialogData.publicBundle.vehiclesValuations[0].garage.title}}
      {{dialogData.publicBundle.vehiclesValuations[0].garage.subTitle}}
    </h3>
  </div>

  <div *ngIf="dialogData.publicBundle.vehiclesValuations.length > 1">
    <h3 class="m-0">
      {{'COMMON.LABEL.PACKAGE_SELECTED' | translate}}:
      <span class="mb-2"
        *ngFor="let vehicleValuation of dialogData.publicBundle.vehiclesValuations; let last = last">
        {{vehicleValuation.garage.title}} {{vehicleValuation.garage.subTitle}}
        <span *ngIf="!last">, </span>
      </span>
    </h3>
  </div>

  <cci-contacts-form [subTitle]="'COMMON.LABEL.ACTIVATE_INVESTMENT_DIALOG_SUBTITLE' | translate"
    [ctaLabel]="'COMMON.LABEL.SEND_REQUEST' | translate"
    (messageSent)="onConfirm()"
    [publicBundle]="dialogData?.publicBundle"
    [vehicle]="dialogData?.vehicle"></cci-contacts-form>
</div>

<!-- <div mat-dialog-actions>
  <button mat-button
    (click)="onCancel()">No Thanks</button>
  <button mat-button
    (click)="onConfirm()"
    cdkFocusInitial>Ok</button>
</div> -->